// extracted by mini-css-extract-plugin
module.exports = {"controller":"filter-control_controller__pXU7K"};